var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.children)?_c('b-collapse',{attrs:{"visible":_vm.isCollapsed,"id":'parentNav-lvl-' + _vm.level + '-' + _vm.index}},[_c('ul',{staticClass:"child-nav-list"},_vm._l((_vm.children),function(ChildNav,_index){return (
        ChildNav.hasOwnProperty('permissions') &&
          _vm.checkNavPermissions(
            ChildNav.permissions,
            ChildNav.cine_direct_sale,
            ChildNav.module_id,
            ChildNav
          )
      )?_c('li',{key:_index},[(
          ChildNav.children &&
            ChildNav.children.length > 0 &&
            ChildNav.isChildrenExist
        )?_c('div',[_c('div',{staticClass:"parent-nav",class:ChildNav.isCollapsed ? null : 'collapsed',attrs:{"aria-expanded":ChildNav.isCollapsed ? 'true' : 'false',"aria-controls":'parentNav-lvl-' + (_vm.level + 1) + '-' + _index},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onHandleCollapsed(_vm.children, _index)}}},[_c('div',{class:ChildNav.icon + ' nav-icon'}),_vm._v(" "),_c('div',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.$tc(ChildNav.name, 2)))])]),_vm._v(" "),_c('sidebar-dropdown',{attrs:{"children":ChildNav.children,"isCollapsed":ChildNav.isCollapsed,"index":_index,"level":_vm.level + 1,"onHandleCollapsed":_vm.onHandleCollapsed}})],1):(
          ChildNav.hasOwnProperty('show')
            ? ChildNav.show
            : ChildNav.hasOwnProperty('ModuleId')
            ? ChildNav.ModuleId != 2
            : true
        )?_c('router-link',{class:[
          ' ',
          _vm.getCurrentSideNavRoute && _vm.getCurrentSideNavRoute === ChildNav.url
            ? 'router-link-exact-active router-link-active'
            : ''
        ],attrs:{"to":ChildNav.url,"title":ChildNav.name},nativeOn:{"click":function($event){return _vm.setCurrentSideNavRoute(ChildNav.url)}}},[_c('div',{staticClass:"d-flex"},[_c('img',{staticClass:"mr-2",attrs:{"src":require("@/assets/img/icons/arrow-right.svg"),"height":"auto","width":"10"}}),_vm._v(" "),_c('span',{style:(ChildNav.hasOwnProperty('ModuleId')
                ? ChildNav.ModuleId == '3'
                  ? 'color:red'
                  : ''
                : '')},[_vm._v("\n            "+_vm._s(_vm.$tc(ChildNav.name, 2))+"\n          ")])])]):_vm._e()],1):_vm._e()}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303f64ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Containers/sidebarDropdown.vue
// module id = null
// module chunks = 